import getImage from "./../../../ClinicHistory/ClinicEvent/components/PdfReports/GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import ReportsAPI from './../../../Reports/api/reports_api';
import { formatNumber } from "../../../Utils/Money";

const pdfStatusAccount = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  console.log("ComingToPDFPayment", data);

  const city = parseInt(data.profile.direccion.id_ciudad);
  const dept = parseInt(data.profile.direccion.id_dpto);
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  const today = new Date();

  const defineContentDetail = (element) => {
    let message = '';
    if (element.hasOwnProperty('num_fac_ter')) {
      message = `Factura: ${element.num_fac_ter}\nvence el ${moment(element.vencimiento).format('DD-MM-YYYY')}`;
    } else if (element.hasOwnProperty('id_pago')) {
      message = `Pago: No. ${element.id_pago}\npara la factura ${searchNameInvoice(element.id_factura_t)}`;
    } else if (element.hasOwnProperty('id_anticipo')) {
      message = `Anticipo: No. ${element.id_anticipo}\npor concepto de: ${element.concepto}`;
    } else if (element.hasOwnProperty('id_recibo')) {
      message = `Abono hecho en recibo No. ${element.num_recibo}\nTipo de abono: ${element.tipo_pago}`;
    } else {
      message = '';
    }
    return message;
  }

  const searchNameInvoice = (id_factura_t) => {
    let nameInvoice = '';
    if (data.allInvoiceFromProfileSearched !== null) {
      let invoice = data.allInvoiceFromProfileSearched.find((invoice) => invoice.id_factura_t === id_factura_t)
      nameInvoice = invoice.num_fac_ter;
    }

    return nameInvoice
  }

  const calculateTotal = (invoice) => {
    let total_tercero = 0;
    let total_abonos = 0;
    if (invoice.hasOwnProperty('servicios')) { //Factura en salud
      if (invoice.servicios !== null && invoice.servicios !== undefined) {
        if (invoice.tipo !== null) {
          if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
            if (invoice.servicios.recibos_caja.length > 0) {
              invoice.servicios.recibos_caja.forEach((recibo) => {
                total_tercero += parseInt(recibo.total)
                total_abonos = 0;
              })
            }
          } else { // cuando es otro regimen 
            if (invoice.servicios.recibos_caja.length > 0) {
              invoice.servicios.recibos_caja.forEach((recibo) => {
                total_tercero += parseInt(recibo.valor_tercero)
                total_abonos += parseInt(recibo.total);
              })
            }
          }
        }
      } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
        total_tercero = parseInt(invoice.detalles_comerciales?.total);
        total_abonos = parseInt(invoice.detalles_comerciales?.copago);
      } else {
        total_tercero = 0;
        total_abonos = 0;
      }
    }
    return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
  }

  const defineValuesTotalInvoiceFromAbonos = (infoInvoice, plusAbonos, soloAbonos) => {
    let valuesInvoice = calculateTotal(infoInvoice);
    if (plusAbonos) {
      return valuesInvoice.total_tercero + valuesInvoice.total_abonos
    } else if (soloAbonos) {
      return valuesInvoice.total_abonos;
    } else {
      return valuesInvoice.total_tercero;
    }
  }

  let bodyBalance = [];

  if(data.clientThrid !== undefined ){
    bodyBalance.push(
      [{ text: 'FECHA', style: "tableheader" },
      { text: 'DETALLES', style: "tableheader" },
      { text: 'VALOR FAC.', style: "tableheaderFloarRight" },
      { text: 'PAGOS/ANTICIPOS', style: "tableheaderFloarRight" },
      { text: 'ABONOS', style: "tableheaderFloarRight" },
      { text: 'BALANCE', style: "tableheaderFloarRight" }],
    )

    try {
      for (let k = 0; k < data.infoStatusAccount.length; k++) {
        const element = data.infoStatusAccount[k];
        bodyBalance.push([
          { text: moment(element.fechaToFilter).format('DD-MM-YYYY'), style: 'textStyle' },
          { text: defineContentDetail(element), style: 'textStyle' },
          { text: element.hasOwnProperty('num_fac_ter') ? data.clientThrid !== undefined ? '$' + formatNumber(defineValuesTotalInvoiceFromAbonos(element, true, false)) : formatNumber(element.hasOwnProperty('num_fac_ter') ? '$' + element.importeBalance : '') : '', style: 'textStyleValueIncome' },
          { text: formatNumber(element.hasOwnProperty('id_pago') ? '$' + element.importe : element.hasOwnProperty('id_anticipo') ? '$' + element.valor : ''), style: 'textStyleValueIncome' },
          { text: element.hasOwnProperty('num_fac_ter') ? '$' + formatNumber(defineValuesTotalInvoiceFromAbonos(element, false, true)) : '', style: 'textStyleValueIncome' },
          { text: '$' + formatNumber(element.accBalance < 0 ? '+' + Math.abs(element.accBalance) : element.accBalance), style: 'textStyleValueIncome' }
        ])
      }
    } catch (error) {
      console.log(error)
    }

  }else{
    bodyBalance.push(
      [{ text: 'FECHA', style: "tableheader" },
      { text: 'DETALLES', style: "tableheader" },
      { text: 'VALOR FAC.', style: "tableheaderFloarRight" },
      { text: 'PAGOS', style: "tableheaderFloarRight" },
      { text: 'BALANCE', style: "tableheaderFloarRight" }],
    )

    try {
      for (let k = 0; k < data.infoStatusAccount.length; k++) {
        const element = data.infoStatusAccount[k];
        bodyBalance.push([
          { text: moment(element.fechaToFilter).format('DD-MM-YYYY'), style: 'textStyle' },
          { text: defineContentDetail(element), style: 'textStyle' },
          { text: element.hasOwnProperty('num_fac_ter') ? data.clientThrid !== undefined ? '$' + formatNumber(defineValuesTotalInvoiceFromAbonos(element, true, false)) : formatNumber(element.hasOwnProperty('num_fac_ter') ? '$' + element.importeBalance : '') : '', style: 'textStyleValueIncome' },
          { text: formatNumber(element.hasOwnProperty('id_pago') ? '$' + element.importe : element.hasOwnProperty('id_recibo') ? '$' + parseInt(element.total) : '' ), style: 'textStyleValueIncome' },
          { text: '$' + formatNumber(element.accBalance < 0 ? '+' + Math.abs(element.accBalance) : element.accBalance), style: 'textStyleValueIncome' }
        ])
      }
    } catch (error) {
      console.log(error)
    }
  }
  
  let nameClient = '';
  if (data.clientThrid !== null && data.clientThrid !== undefined) {
    nameClient = data.clientThrid.nombre;
  } else if (data.clientPacient !== null && data.clientPacient !== undefined) {
    nameClient = data.clientPacient.nombres + ' ' + data.clientPacient.apellido1 + ' ' + data.clientPacient.apellido2;
  } else {
    nameClient = '';
  }

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.direccion.direccion +
              " " +
              data.profile.nombre +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2,
            style: "head",
          },
        ],
      ],
    },
  };

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [30, 70, 30, 40],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              {
                text:
                  "Fecha Impresión: " + moment(today).format('DD-MM-YYYY'),
                style: "head",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 30, 5],
      };
    },
    content: [
      {
        columns: [
          {
            table: {
              widths: ["auto", "*"],
              body: [
                [{ text: 'Para', style: "headPayment", alignment: 'left' }, ''],
                [{ text: nameClient, style: "textStyle", alignment: 'left' }, ''],
              ],
            },
            layout: "noBorders",
            margin: [20, 10, 0, 10],
          },
          {
            table: {
              widths: ["*", "auto"],
              body: [
                ['', { text: data.profile.nombre, style: "textStyle", alignment: 'right', bold: true }],
                ['', { text: data.profile.direccion.direccion, style: "textStyle", alignment: 'right' }],
                ['', { text: getCity[0].ciunom + '-' + deptoProfile.depnom, style: "textStyle", alignment: 'right' }],
                ['', { text: 'NIT.: ' + data.profile.nit, style: "textStyle", alignment: 'right' }],
              ],
            },
            layout: "noBorders",
            margin: [20, 10, 0, 10],
          },
        ]
      },
      { text: "SALDO DE CUENTA", style: "headPayment", alignment: 'right' },
      {
        columns: [
          {
            table: {
              widths: ["auto", "*"],
              body: [
                ['', ''],
                ['', ''],
              ],
            },
            layout: "noBorders",
            margin: [20, 10, 0, 20],
          },
          data.clientThrid !== undefined ?
          {
            table: {
              widths: ["*", "auto"],
              body: [
                ['', { text: moment(data.startDate).format('DD-MM-YYYY') + ' a ' + moment(data.endDate).format('DD-MM-YYYY'), style: "textStyle", alignment: 'right' }],
                [{ text: 'Comenzando balance: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.infoStatusAccount[0].accBalance < 0 ? '+' + Math.abs(data.infoStatusAccount[0].accBalance) : data.infoStatusAccount[0].accBalance) , style: "textStyle", alignment: 'right' }],
                [{ text: 'Total facturado: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalInvoices), style: "textStyle", alignment: 'right' }],
                [{ text: 'Total pagado: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalPagos), style: "textStyle", alignment: 'right' }],
                [{ text: 'Total abonos: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalAbonos), style: "textStyle", alignment: 'right' }],
                [{ text: 'Total retenciones: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalRetenciones), style: "textStyle", alignment: 'right' }],
                [{ text: 'Balance vencido: ', style: "textStyle", alignment: 'left', bold: true }, { text: '$' + formatNumber(data.infoStatusAccount[data.infoStatusAccount.length - 1] !== undefined ? data.infoStatusAccount[data.infoStatusAccount.length - 1].accBalance - data.mountTotalStatusAccount?.totalRetenciones : ''), style: "textStyle", alignment: 'right' }],
              ],
            },
            layout: "noBorders",
            margin: [20, 10, 0, 10],
          }
          :
          {
            table: {
              widths: ["*", "auto"],
              body: [
                ['', { text: moment(data.startDate).format('DD-MM-YYYY') + ' a ' + moment(data.endDate).format('DD-MM-YYYY'), style: "textStyle", alignment: 'right' }],
                [{ text: 'Comenzando balance: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.infoStatusAccount[0].accBalance < 0 ? '+' + Math.abs(data.infoStatusAccount[0].accBalance) : data.infoStatusAccount[0].accBalance) , style: "textStyle", alignment: 'right' }],
                [{ text: 'Total facturado: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalInvoices), style: "textStyle", alignment: 'right' }],
                [{ text: 'Total pagado: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalPagos), style: "textStyle", alignment: 'right' }],
                [{ text: 'Total retenciones: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalRetenciones), style: "textStyle", alignment: 'right' }],
                [{ text: 'Balance vencido: ', style: "textStyle", alignment: 'left', bold: true }, { text: '$' + formatNumber(data.infoStatusAccount[data.infoStatusAccount.length - 1] !== undefined ? data.infoStatusAccount[data.infoStatusAccount.length - 1].accBalance - data.mountTotalStatusAccount?.totalRetenciones : ''), style: "textStyle", alignment: 'right' }],
              ],
            },
            layout: "noBorders",
            margin: [20, 10, 0, 10],
          }
        ]
      },
      data.startDate !== null && data.endDate !== null ?
        { text: "Mostrando todas las facturas y pagos entre " + moment(data.startDate).format('DD-MM-YYYY') + ' y ' + moment(data.endDate).format('DD-MM-YYYY'), style: "textStyle", alignment: 'center' }
        : null,
      {
        table: {
          headerRows: 1,
          widths: [540],
          body: [
            [''],
            ['']
          ]
        },
        layout: 'headerLineOnly',
        margin: [20, 10, 0, 20]
      },
      data.clientThrid !== undefined ?
        {
          table: {
            widths: ["auto", "auto", "*", "*", '*', "*"],
            body: bodyBalance,
          },
          layout: "lightHorizontalLines",
          margin: [20, 10, 0, 20],
        }
        :
        {
          table: {
            widths: ["auto", "auto", "*", "*", "*"],
            body: bodyBalance,
          },
          layout: "lightHorizontalLines",
          margin: [20, 10, 0, 20],
        },
      {
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*", "*"],
          body: [
            ['', '', '', { text: 'Total retenciones: ', style: "textStyle", alignment: 'left' }, { text: '$' + formatNumber(data.mountTotalStatusAccount?.totalRetenciones), style: "textStyle", alignment: 'right' }],
            ['', '', '', { text: 'Balance vencido: ', style: "textStyle", alignment: 'left', bold: true }, { text: '$' + formatNumber(data.infoStatusAccount[data.infoStatusAccount.length - 1] !== undefined ? data.infoStatusAccount[data.infoStatusAccount.length - 1].accBalance - data.mountTotalStatusAccount?.totalRetenciones : ''), style: "textStyle", alignment: 'right' }],
          ]
        },
        layout: 'noBorders',
        margin: [20, 0, 10, 20]
      },
    ],
    styles: {
      headPayment: {
        fontSize: 12,
        bold: true,
      },
      headResumenPayment: {
        fontSize: 10,
        bold: true,
      },
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      tableheaderFloarRight: {
        fontSize: 11,
        bold: true,
        alignment: 'right'
      },
      textStyle: {
        fontSize: 10,
      },
      textStyleValueIncome: {
        fontSize: 10,
        alignment: "right"
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 5, 0, 0],
        fontSize: 10,
        alignment: "left",
      },
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });

  //pdfMake.createPdf(documentDefinition).open();
};
export default pdfStatusAccount;
